import styled from '@emotion/styled';
export const StyledGiftCardContainer = styled.div(() => ({
    width: '100%',
}));
